var map = {
	"./star.png": 66,
	"./star@2x.png": 67
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img ^\.\/star.*\.png$
// module id = 122
// module chunks = d-game